<template>
  <div class="relative" ref="dropdownRef">
    <button
      @click="toggleDropdown"
      class="flex items-center justify-between gap-2 text-white font-plus-jakarta text-sm font-medium leading-6 hover:text-brand transition-colors duration-250 min-w-[80px]"
      :aria-expanded="isOpen"
      aria-haspopup="true"
    >
      <span class="whitespace-nowrap">{{ currentLanguage.label || currentLanguage.name }}</span>
      <svg
        class="w-5 h-5 flex-shrink-0 transition-transform duration-250"
        :class="{ 'rotate-180': isOpen }"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>

    <Transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition ease-in duration-150"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div
        v-if="isOpen"
        class="absolute right-0 mt-2 rounded-lg bg-[rgba(0,0,0,0.8)] backdrop-blur-sm shadow-[0px_16px_32px_0px_rgba(0,0,0,0.1),0px_8px_16px_0px_rgba(0,0,0,0.1),0px_4px_8px_0px_rgba(0,0,0,0.1),0px_2px_4px_0px_rgba(0,0,0,0.1)] overflow-hidden z-[100] p-2"
      >
        <div class="flex flex-col gap-2">
          <button
            v-for="language in locales"
            :key="language.code"
            @click="selectLanguage(language)"
            class="w-full px-2 py-1 text-left text-sm font-plus-jakarta font-medium leading-6 transition-colors duration-200 whitespace-nowrap text-white hover:text-brand rounded"
            :class="[
              language.code === currentLanguage.code ? 'text-brand' : ''
            ]"
          >
            {{ language.label || language.name }}
          </button>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";

const { locale, locales, setLocale } = useI18n();

const isOpen = ref(false);
const dropdownRef = ref(null);

const currentLanguage = computed(() => {
  return (
    locales.value.find((lang) => lang.code === locale.value) || locales.value[0]
  );
});

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const selectLanguage = (language) => {
  setLocale(language.code);
  isOpen.value = false;
};

const handleClickOutside = (event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});
</script>
